// extracted by mini-css-extract-plugin
module.exports = {"Control":"css-modules_Control__4TLlA","Track":"css-modules_Track__j5vTf","Indicator":"css-modules_Indicator__j07A2","Thumb":"css-modules_Thumb__z3kAv"};